function WrongIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='44' height='43' fill='none' viewBox='0 0 44 43'>
      <path
        fill='#EE404C'
        d='M19.809 9.01l-12.3 21.302a2.53 2.53 0 002.192 3.796h24.596a2.531 2.531 0 002.192-3.796L24.19 9.011a2.53 2.53 0 00-4.382 0z'
      />
      <path
        fill='#FFF7ED'
        d='M22.16 15.58h-.32c-.79 0-1.43.64-1.43 1.43v6.837c0 .79.64 1.43 1.43 1.43h.32c.79 0 1.43-.64 1.43-1.43V17.01c0-.79-.64-1.43-1.43-1.43zM22 30.699a1.59 1.59 0 100-3.182 1.59 1.59 0 000 3.182z'
      />
    </svg>
  );
}

export default WrongIcon;
